import { Divider, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import ControlledTextEditor from 'src/shared/components/form/controlledTextEditor';

type WebFormSettingsOverviewProps = {
  isEditable: boolean;
};

export const WebFormSettingsOverview = (props: WebFormSettingsOverviewProps) => {
  const { isEditable } = props;
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Grid item xs={12} mb={3}>
        <Typography variant='h6' sx={{ fontWeight: 600, mt: 2 }} gutterBottom>
          {t('webforms:settings')}
        </Typography>
        <Divider />
      </Grid>
      <Grid item xs={12} lg={6} mb={2}>
        <ControlledTextField
          fullWidth
          label={t('fundraiser:welcomePageUrl')}
          placeholder='https://'
          size='small'
          name='welcomeURL'
          disabled={!isEditable}
        />
      </Grid>
      <Grid item xs={12} lg={6} mb={2}>
        <ControlledTextField
          fullWidth
          label={t('fundraiser:emailDispatchHeading')}
          placeholder='https://'
          size='small'
          name='subjectSender'
          disabled={!isEditable}
        />
      </Grid>
      <Grid item xs={12} lg={6} height='auto'>
        <ControlledTextEditor name='bodySender' disabled={!isEditable} />
      </Grid>
    </Grid>
  );
};
